/* eslint-disable import/prefer-default-export */
import ajax from './ajax';
import { hasAccessToken } from '../../../../../../utils/token';

/**
 * HELPERS
 */

const encodeData = data => {
	if (!data) {
		return data;
	}

	if (data instanceof Object) {
		return JSON.stringify(data);
	}

	return data;
};

const createPromiseRequest = ({
	url,
	data: paramData,
	method = 'GET',
	aip = 'scanline',
	isAnonymous
}) => () => {
	const data = encodeData(paramData);	
	return new Promise((resolve, reject) => {
		ajax(
			url,
			data,
			method,
			(err, res) => {
				if (err) {
					reject(err);
				} else {
					resolve(res);
				}
			},
			isAnonymous,
			aip
		);
	});
};


/**
 * MAIN
 */

export const fetchLineHistorySummaries = async ({ lineId, lineGuid } = {}) => {
	const url = '/line/app-state-and-report-history-summaries';

	if (hasAccessToken()) {
		const fetchData = createPromiseRequest({
			url,
			method: 'POST',
			data: { lineId, lineGuid }
		});

		return fetchData().then((historySummaries = {}) => { 
			return historySummaries;
		});
	}
	return Promise.reject(new Error('Missing Token'));
};




